import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RaceDriverComponent } from './race-driver/race-driver.component';
const routes: Routes = [
  {
    path:'raceDriver',
    component:RaceDriverComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RaceDriverRoutingModule { }
